import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface Testimonial {
  quote: string;
  name: string;
  role: string;
  company: string;
  initials: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Redujimos el robo de combustible en un 40% en el primer mes. La inversión se pagó sola en semanas.',
  name: 'Roberto Méndez',
  role: 'Director de Operaciones',
  company: 'Transportes del Norte',
  initials: 'RM'
}, {
  quote: 'La plataforma es muy completa y el soporte 24/7 ha sido clave para nuestra operación. Excelente servicio.',
  name: 'María González',
  role: 'Gerente de Flotilla',
  company: 'Distribuidora Central',
  initials: 'MG'
}, {
  quote: 'Mi familia tiene paz mental sabiendo dónde está el auto en todo momento. La app es muy fácil de usar.',
  name: 'Carlos Hernández',
  role: 'Cliente Particular',
  company: 'Ciudad de México',
  initials: 'CH'
}];
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="nosotros" ref={ref} className="w-full bg-brand-primary py-20 md:py-28" data-id="element-628">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-629">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-630">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4" data-id="element-631">
            Lo que dicen nuestros clientes
          </h2>
          <p className="font-body text-lg text-brand-text-secondary max-w-2xl mx-auto" data-id="element-632">
            Más de 500 vehículos confían en TrackerSpaceMx
          </p>
        </motion.div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-633">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 30
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="group" data-id="element-634">
              <div className="h-full glass rounded-2xl p-6 md:p-8 border border-cyan-subtle hover:border-brand-accent/30 transition-all duration-300" data-id="element-635">
                {/* Quote Icon */}
                <div className="mb-4" data-id="element-636">
                  <QuoteIcon className="w-8 h-8 text-brand-accent/30" data-id="element-637" />
                </div>

                {/* Quote */}
                <p className="font-body text-lg text-white mb-6 leading-relaxed" data-id="element-638">
                  "{testimonial.quote}"
                </p>

                {/* Stars */}
                <div className="flex gap-1 mb-6" data-id="element-639">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-brand-accent fill-brand-accent" data-id="element-640" />)}
                </div>

                {/* Author */}
                <div className="flex items-center gap-4" data-id="element-641">
                  {/* Avatar */}
                  <div className="w-12 h-12 rounded-full bg-brand-accent/20 flex items-center justify-center border border-brand-accent/30" data-id="element-642">
                    <span className="font-heading font-bold text-brand-accent" data-id="element-643">
                      {testimonial.initials}
                    </span>
                  </div>

                  {/* Info */}
                  <div data-id="element-644">
                    <p className="font-subheading font-medium text-white" data-id="element-645">
                      {testimonial.name}
                    </p>
                    <p className="font-body text-sm text-brand-text-secondary" data-id="element-646">
                      {testimonial.role}
                    </p>
                    <p className="font-body text-xs text-brand-accent" data-id="element-647">
                      {testimonial.company}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}